import api from "./api";

function b64ToUint8(value) {
    const padding = "=".repeat((4 - (value.length % 4)) % 4);
    const raw = atob((value + padding).replace(/-/g, "+").replace(/_/g, "/"));
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export async function currentSubscription() {
    if (!pushSupported()) return null;
    const reg = await navigator.serviceWorker.ready;
    return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
    if (!pushSupported()) throw new Error(isIOS() && !isStandalone() ? "Na iPhonu nejdřív přidejte aplikaci na plochu (Sdílet → Přidat na plochu) a otevřete ji odtud." : "Tento prohlížeč push notifikace nepodporuje.");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") throw new Error("Notifikace jsou v prohlížeči zakázané – povolte je v nastavení webu.");
    const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
    await navigator.serviceWorker.ready;
    const { data } = await api.get("/push/public-key");
    if (!data.configured) throw new Error("Push notifikace nejsou na serveru nakonfigurované.");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.publicKey) });
    await api.post("/push/subscribe", { ...sub.toJSON(), device: navigator.userAgent.slice(0, 120) });
    return sub;
}

export async function unsubscribeFromPush() {
    const sub = await currentSubscription();
    if (!sub) return;
    await api.delete("/push/subscribe", { data: { endpoint: sub.endpoint } });
    await sub.unsubscribe();
}
